module.exports = __webpack_public_path__ + "static/media/Gotham-Light.1185933e.woff";